<template>
  <div id="detail">
      <div class="container detail-container">
        <div class="title">{{ detail.title }}</div>
        <div class="info-wrap d-flex justify-between align-center"  style="clear:both;overflow:hidden">
            <div class="info-wrap_left d-flex align-center">
                <div class="info-avatar">
                <img class="avatar" :src="detail.icon ? detail.icon : `${imgPath}/user.png`">
                </div>
                <div class="info-item">
                <div class="name">{{ detail.createUserName }}</div>
                <div class="info-desc d-flex">
                    <div class="date">{{ detail.publishTime | getTime }}</div>
                    <div class="spot">·</div>
                    <div class="address">{{ detail.locationName }}网友</div>
                </div>
                </div>
            </div>
        </div>
        <div class="center" style="clear:both;overflow:hidden">
            <div class="desc">
                {{ detail.content }}
            </div>
            <template
                v-if="detail.attachmentList && detail.attachmentList.length > 0"
            >
                <div
                v-for="(item, index) in detail.attachmentList"
                :key="item.videoPictureUrl"
                >
                <div class="img-list d-flex justify-center" v-if="item.fileType == 0">
                    <!-- 展示图片 -->
                    <img
                    :src="item.fileUrl"
                    class="img">
                </div>
                <div class="img-list  d-flex justify-center" v-if="item.fileType == 1">
                    <!-- 展示视频 -->
                    <video class="video" :src="item.fileUrl" controls></video>
                </div>
                </div>
            </template>
        </div>
        <!-- 联系作者 -->
        <div class="author-list">
          <div class="list-item" v-if="detail.mediaNames">
            <template v-for="(name, index) in detail.mediaNames.split(' ')">
              <div class="item" v-if="name != ''" :key="index">
                <div>{{ name }}</div>
              </div>
            </template>
            <!-- 记者已关注 -->
            <div class="item reporter" v-if="detail.mediaAttentFlag == '1'  &&  detail.mediaNames.indexOf('疫情防控')<0 && detail.mediaNames.indexOf('灾后重建')<0">
              <div>记者已关注</div>
            </div>
          </div>

          <div class="list-item" v-if="detail.creporterName">
            <div class="list-name">{{ detail.creporterName }}</div>
            <div class="list-name" style="background: #eaf7ff; color: #036eb8" v-if="detail.creporterAttentFlag == 1  &&  detail.mediaNames.indexOf('疫情防控')<0 && detail.mediaNames.indexOf('灾后重建')<0"
        >记者站已关注</div>
          </div>
          <div class="list-item" v-if="detail.cmediaName">
            <div class="list-name">{{ detail.cmediaName }}</div>
            <div class="list-name" v-if="detail.cmediaDealFlag == 1  &&  detail.mediaNames.indexOf('疫情防控')<0 && detail.mediaNames.indexOf('灾后重建')<0"
              style="background: #fce0de; color: #f8332e" 
              >县域融媒已办理</div>
          </div>
        </div>
        <!-- 时间轴 -->
        <!-- <template v-if="progressData.length > 0">
            <time-line :progress="progressData" :detail="detail"></time-line>
        </template> -->
        <!-- 评论展示列表 -->
        <div class="comment-wrap container" id="topList">
            <div class="comment-ttile" v-if="commentTotal > 0" >评论({{ commentTotal }})</div>
            <!-- 评论列表 -->
            <template v-if="detail.id">
            <comment-list @openEwm="openDialog" ref="commentRef" :detailObj="detail"></comment-list>
            </template>
        </div>
        <!-- 回复功能 -->
        <div class="reply-wrap"  @click="openDialog">
          <div class="container reply">
            <div class="reply-input d-flex align-center">
              <img class="icon" src="../../static/write.png" >
              <div class="txt">我来说两句...</div>
            </div>
            <div class="reply-list d-flex align-center justify-between">
              <div class="list-item">
                <div class="icon" v-if="commentTotal > 0">{{ commentTotal }}</div>
                <img src="../../static/comment.png">
              </div>
            </div>
          </div>
        </div>
      </div>
       <el-dialog
    title=""
    :visible.sync="dialogVisible"
    width="500px"
    height="360px"
    :before-close="handleClose">
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import CommentList from "@/components/CommentList/CommentList.vue";
 import  { getTimer,imgPath } from "@/util/timer.js"
export default {
   components: {
     CommentList
  },
  data() {
    return {
      id: "",
      imgPath: imgPath,
      detail: {}, //详情
      imgArray: [], //图片
      progressData: [], //时间轴处理
      commentList: [], //评论列表
      commentTotal: 0, //评论数量
      isGz: false, //是否关注
      isDz: false, //是否点赞
      isSc: false, //是否收藏
      isPopupShow: false,
      getHeight: "",
      commentTop: "",
       dialogVisible: false,
    };
  },
  async mounted() {
      console.log(this.$route.query.id)
      if (this.$route.query.id && this.$route.query.id != "") {
      this.id = this.$route.query.id;
      await this.getDetail();
      await  this.getTimeLine();
      await this.getCommentTotal();
    }
  },
  filters: {
    getTime(val) {
      return getTimer(val);
    },
  },
  methods: {
    openDialog(){
      this.dialogVisible=true;
      console.log(this.dialogVisible)
    },
   async getDetail() {
      const config = {
            method: 'get',
            url: `https://pubmod.hntv.tv/plugins_dxrx/public/info/detail?hlId=${this.id}`,
        }
        const { data } = await axios(config);
        if (data.code === 0) {
           this.detail = data.result;
           this.imgArray = data.result.attachmentList;
            // this.getShare();
        }
    },
    //获取时间轴数据
    async getTimeLine() {
       const config = {
            method: 'get',
            url: `https://pubmod.hntv.tv/plugins_dxrx/public/info/detail/progress?hlId=${this.id}`,
        }
        const { data } = await axios(config);
        if (data.code == 0) {
            if (data.result.length > 0) {
              this.progressData = data.result.map((item) => {
                if (item.createTime && item.createTime.includes(" ")) {
                  let arr = item.createTime.split(" ");
                  let date = arr[0].split("-");
                  item.day = date[2];
                  if (date[1] && date[1].charAt(0) == "0") {
                    item.month = date[1].charAt(1);
                  } else {
                    item.month = date[1];
                  }
                  item.time = arr[1];
                }
                return item;
              });
              console.log(this.progressData)
            }
          }
    },
    // 获取评论数量
    async getCommentTotal() {
      if (!this.id) return;
      let ids = this.id.match(/\d+/g)[0];
        const config = {
            method: 'get',
            url: `https://pubmod.hntv.tv/dx-bridge/total-comment-num-dx/${ids}`,
        }
        const { data } = await axios(config);
        if (data.code == 0) {
            this.commentTotal = data.result;
        }
     
    },
  },
  computed: {
   
  },
};
</script>

<style lang="scss" scoped>
	#detail {
		width: 1200px;
        margin:0px auto;
		height: 100%;
	}
.detail-container {
  

  .title {
    padding-top:30px;
    font-size:18px;
    font-weight: bold;
    color: #444444;
    line-height: 1.5;
  }

  .info-wrap {
    margin-top:20px;

    // padding-bottom: 25px;
    // border-bottom: 1px solid #ECECEC;
    .info-wrap_left {
      .info-avatar {
        width: 60px;
        height: 60px;

        .avatar {
          width: 100%;
          height: 100%;
        }
      }

      .info-item {
        margin-left: 10px;
        .name {
          font-weight: 700;
          font-size:16px;
          color: #444444;
        }

        .info-desc {
          padding-top:8px;
          font-size:14px;
          color: #999999;

          .spot {
            padding: 0 8px;
          }
        }
      }
    }

    .info-wrap_right {
      .notice {
        width: 98px;
        height: 48px;
        font-size:14px;
        color: #ffffff;
        line-height: 48px;
        text-align: center;
        background: #ed9027;
        border-radius: 24px;
      }
    }
  }

  .center {
    margin-top:20px;
    line-height: 2.0;
    text-indent: 2em;
    font-size:20px;
    color: #444444;

    .img-list {
      display: flex;
    //   flex-direction: column;

      .img {
       max-width: 800px;height: auto;display: block;
      }

      .video {
       max-width: 800px;height: auto;
      }
    }
  }

  .author-list {
    margin-top:15px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #ececec;

    .list-item {
      display: flex;
      flex-wrap: wrap;

      .item {
        height: 42px;
        line-height: 42px;
        background: #f8f8f8;
        color: #666666;
        font-size:14px;
        margin-bottom: 10px;
        margin-right: 10px;
        border-radius: 5px;
        padding: 0 20px;

        .address {
          display: inline-block;
          width: 14px;
          height: 22px;
          margin-right: 10px;
        }
      }

      .reporter {
        background: #ffedd8;
        color: #ed9027;
      }
    }

    .list-name {
      display: block;
      height: 42px;
      line-height: 42px;
      color: #666666;
      font-size:14px;
      margin-bottom:10px;
      margin-right: 10px;
      border-radius: 5px;
      padding: 0 20px;
      width: auto;
      background: #f8f8f8;
    }

    .reporter {
      color: #ed9027;
      background: #ffedd8;
    }

    .county {
      color: #f8332e;
      background: #fce0de;
    }
  }

  // 评论列表
  .comment-wrap {
    margin-top: 27px;
    margin-bottom: 70px;
  }

  // 底部
  .reply-wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    border-top: 3px solid #f5f5f5;
    height: 60px;
    background-color: #ffffff;
    z-index: 99;
    .reply {
      width: 1200px;
      margin:0px auto;
      height:50px;
      display: flex;
      align-items: center;
      justify-content:center;;
      align-items: center; 
      padding-top:8px;

      .reply-input {
        width: 600px;
        height: 40px;
        background: #f5f5f5;
        border-radius: 35px;

        .icon {
          width:25px;
          height: auto;
          margin-left:20px;
        }

        .txt {
          padding-left: 13px;
          font-size:18px;
          color: #6e6e6e;
        }
      }

      .reply-list {
        padding-left: 36px;

        .list-item {
          position: relative;
          width:30px;
          height: 30px;
          padding-right: 40px;

          img {
            width: 100%;
            height: 100%;
          }

          &:last-child {
            padding-right: 0;
          }

          .icon {
            position: absolute;
            top: -10px;
            right: -20px;
            font-size: 18px;
            color: #ffffff;
            padding: 0px 6px;
            background-color: #007fd6;
            border-radius: 10px;
            z-index: 999;
          }
        }
      }
    }
  }
}
.comment-ttile{font-size: 22px;}
</style>
